import React from "react";

const Steps = ({ steps, step }) => {
	const items = [];

	for (let i = 0; i < steps - 1; i++) {
		const n = i + 1;
		const active = n <= parseInt(step) ? " active" : "";
		items.push(
			<div key={`step${n}`} className={`item-step${active}`}>
				<span>{n}</span>
			</div>
		);
		if (n < steps - 1) items.push(<div key={`sep${n}`} className={`item-sep`}></div>);
	}

	return <div className="steps">{items}</div>;
};

export default Steps;
